import { prepareZXingModule, readBarcodes } from 'zxing-wasm/reader';
import type { ReadResult } from 'zxing-wasm/reader';
import type { BinBbox, DecodedSymbol } from '../types';

const moduleReady = prepareZXingModule({ fireImmediately: true });

export const decoderReady: Promise<void> = moduleReady.then(() => undefined);

export type DecodeOutcome =
  | { kind: 'symbols'; symbols: DecodedSymbol[] }
  | { kind: 'none' };

export async function decodeFrame(input: Blob | ImageData): Promise<DecodeOutcome> {
  const results = await readBarcodes(input, {
    formats: ['QRCode'],
    // 255 (the library default) is a foot-gun with tryHarder: ZXing
    // keeps scanning the residual image after each detection until
    // the cap, multiplying per-frame decode cost. Real sweeps never
    // show more than a handful of bins per frame.
    maxNumberOfSymbols: 8,
    tryHarder: true,
  });

  const symbols = results
    .filter((r) => r.isValid && r.text.length > 0)
    .map(toDecodedSymbol);

  return symbols.length === 0 ? { kind: 'none' } : { kind: 'symbols', symbols };
}

function toDecodedSymbol(r: ReadResult): DecodedSymbol {
  const { topLeft: tl, topRight: tr, bottomLeft: bl, bottomRight: br } = r.position;
  const bbox: BinBbox = {
    x1: Math.min(tl.x, tr.x, bl.x, br.x),
    y1: Math.min(tl.y, tr.y, bl.y, br.y),
    x2: Math.max(tl.x, tr.x, bl.x, br.x),
    y2: Math.max(tl.y, tr.y, bl.y, br.y),
  };
  return { text: r.text, bbox, orientation: r.orientation, kind: 'qr' };
}
